module.exports = __webpack_public_path__ + "c3ba29aa0093f1d9e3f58b2906dc105f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-26.png
// module id = 2672
// module chunks = 0